import { graphql, StaticQuery } from "gatsby"
import React from "react"
import CaseStudyCard from "./case-study/case-study-card"
import { LOGO_PLACEMENT } from "./case-study/brand-logo-scales"

const EMPTY_SLUGS = []

export default ({
  limit = Number.POSITIVE_INFINITY,
  ignoreSlugs = EMPTY_SLUGS,
  className = "",
  logoContext = LOGO_PLACEMENT.homepageCaseStudyCards,
}) => (
  <StaticQuery
    query={graphql`
      query {
        allWordpressAcfCaseStudies {
          nodes {
            id
            acf {
              slug
              external_url
              brand_logo_1
              brand_logo_2
              brand_logo_3
              custom_post_title
              order
              hero {
                localFile {
                  childImageSharp {
                    fluid(
                      maxHeight: 337
                      maxWidth: 524
                      quality: 80
                      cropFocus: CENTER
                    ) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <div className={`container pb-6 ${className}`.trim()}>
        <div className="case-studies-grid">
          {data.allWordpressAcfCaseStudies.nodes
            .slice()
            .sort((a, b) => (a.acf?.order || 0) - (b.acf?.order || 0))
            .filter(caseStudy => !ignoreSlugs.includes(caseStudy.acf.slug))
            .slice(0, limit)
            .map((caseStudy, index) => (
              <CaseStudyCard
                caseStudy={caseStudy.acf}
                key={caseStudy.id}
                logoContext={logoContext}
                wide={
                  index === 2 &&
                  data.allWordpressAcfCaseStudies.nodes.length % 2 === 1
                }
              />
            ))}
        </div>
      </div>
    )}
  />
)
